module.exports = __webpack_public_path__ + "img/744.6fd7bd46.jpg";